enum ProjectActionsEnum {
    prevProject = 'prevProject',
    nextProject = 'nextProject'
}

export default ProjectActionsEnum;
